export default "__VITE_ASSET__CDuqnZVQ__"